import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import { pathBuilder, dateBuilder, assetPathBuilder } from '../utils/pathBuilder';
import { ReactComponent as Calendar } from '../images/svgs/calendar-regular.svg';
import styles from '../styles/components/mainPanelCard.module.scss';

const MainPanelCard = ({
  title, previewText, image, category, date, language,
}) => {
  const convertedDate = dateBuilder(date).split('-').reverse().join('/');
  const path = pathBuilder(language, date, title);
  const assetPath = assetPathBuilder(image);

  return (
    <div className={styles.container}>
      <div className={styles.categoryTag}>
        <span>
          <FormattedMessage
            id={`category.${category}`}
          />
        </span>
      </div>
      <Link className={styles.content} to={path}>
        <img src={assetPath} alt={title} />
        <div className={styles.header}>
          <h3>{title}</h3>
          <div className={styles.date}>
            <Calendar />
            <span>
              {convertedDate}
            </span>
          </div>
        </div>
        <p>{previewText}</p>
      </Link>
    </div>
  );
};

MainPanelCard.propTypes = {
  category: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  previewText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default MainPanelCard;
